import { useState } from 'react';

const apiBase = () => (process.env.REACT_APP_STRAPI_BASE_URL || '').replace(/\/$/, '');
const sessionKey = 'starekomputery.review-session';

function readSession() {
  if (typeof window === 'undefined') return null;
  try { return JSON.parse(window.sessionStorage.getItem(sessionKey) || 'null'); } catch { return null; }
}

async function request(path, options = {}) {
  const response = await fetch(`${apiBase()}${path}`, { headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }, ...options });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result?.error?.message || result?.message || 'Nie udało się zapisać opinii.');
  return result;
}

export default function HardwareReviewForm({ hardwareModelDocumentId, modelName }) {
  const [session, setSession] = useState(readSession);
  const [mode, setMode] = useState('login');
  const [identifier, setIdentifier] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rating, setRating] = useState('5');
  const [body, setBody] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const authenticate = async (event) => {
    event.preventDefault();
    setBusy(true); setMessage('');
    try {
      const payload = mode === 'login'
        ? { identifier, password }
        : { username: identifier, email, password };
      const endpoint = mode === 'login' ? '/api/auth/local' : '/api/auth/local/register';
      const result = await request(endpoint, { method: 'POST', body: JSON.stringify(payload) });
      const next = { jwt: result.jwt, username: result.user?.username || identifier };
      window.sessionStorage.setItem(sessionKey, JSON.stringify(next));
      setSession(next); setPassword(''); setMessage('Konto jest gotowe do wysłania opinii.');
    } catch (error) { setMessage(error.message); } finally { setBusy(false); }
  };

  const submitReview = async (event) => {
    event.preventDefault();
    setBusy(true); setMessage('');
    try {
      await request('/api/hardware-reviews', {
        method: 'POST', headers: { Authorization: `Bearer ${session.jwt}` },
        body: JSON.stringify({ data: { hardwareModelDocumentId, rating: Number(rating), body } }),
      });
      setBody(''); setMessage('Dziękujemy. Opinia oczekuje na moderację i pojawi się po publikacji.');
    } catch (error) { setMessage(error.message); } finally { setBusy(false); }
  };

  if (!apiBase()) return null;
  return <section className="retro-review-form" aria-labelledby="review-form-title">
    <h3 id="review-form-title">Dodaj opinię o modelu</h3>
    <p>Opinia dotyczy modelu {modelName}. Po wysłaniu sprawdza ją redakcja.</p>
    {session ? <form onSubmit={submitReview}>
      <label>Ocena <select value={rating} onChange={(event) => setRating(event.target.value)}><option value="5">5 — świetny</option><option value="4">4 — dobry</option><option value="3">3 — przeciętny</option><option value="2">2 — słaby</option><option value="1">1 — bardzo słaby</option></select></label>
      <label>Twoja opinia <textarea value={body} minLength="20" maxLength="2000" required onChange={(event) => setBody(event.target.value)} /><span>{body.length}/2000 znaków</span></label>
      <button className="retro-button retro-button-primary" disabled={busy} type="submit">{busy ? 'Wysyłanie…' : 'Wyślij do moderacji'}</button>
      <button className="retro-review-signout" type="button" onClick={() => { window.sessionStorage.removeItem(sessionKey); setSession(null); }}>Wyloguj konto {session.username}</button>
    </form> : <form onSubmit={authenticate}>
      <div className="retro-review-mode"><button type="button" aria-pressed={mode === 'login'} onClick={() => setMode('login')}>Zaloguj się</button><button type="button" aria-pressed={mode === 'register'} onClick={() => setMode('register')}>Załóż konto</button></div>
      <label>{mode === 'login' ? 'E-mail lub nazwa użytkownika' : 'Nazwa użytkownika'}<input value={identifier} required onChange={(event) => setIdentifier(event.target.value)} /></label>
      {mode === 'register' && <label>E-mail<input type="email" value={email} required onChange={(event) => setEmail(event.target.value)} /></label>}
      <label>Hasło<input type="password" value={password} required minLength="6" onChange={(event) => setPassword(event.target.value)} /></label>
      <button className="retro-button retro-button-primary" disabled={busy} type="submit">{busy ? 'Trwa…' : mode === 'login' ? 'Zaloguj się' : 'Załóż konto'}</button>
    </form>}
    {message && <p className="retro-review-message" role="status">{message}</p>}
  </section>;
}
